import { render, staticRenderFns } from "./TaxCard.vue?vue&type=template&id=6f419190&scoped=true&"
import script from "./TaxCard.vue?vue&type=script&lang=js&"
export * from "./TaxCard.vue?vue&type=script&lang=js&"
import style0 from "./TaxCard.vue?vue&type=style&index=0&id=6f419190&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f419190",
  null
  
)

export default component.exports